<div class="card-style link-card"
     [ngClass]="{
          'link-card--wide' : isWide || (!link?.iconImageUrl && !link?.icon),
          'link-card--row' : isRow
     }"   (click)="onMainClick()">
  <div class="link-card__main">
    <!-- <img *ngIf="link?.iconImageUrl" [src]="link?.iconImageUrl"/> -->
    @if (link?.iconImageUrl && !isSvgIcon()) {
      <sb-icon-img
        [imgUrl]="link?.iconImageUrl"
      class="link-card__icon"></sb-icon-img>
    }
    @if (link?.iconImageUrl && isSvgIcon()) {
      <sb-icon-svg-img
        [imgUrl]="link?.iconImageUrl"
      class="link-card__icon"></sb-icon-svg-img>
    }
    @if (link?.icon && !link?.iconImageUrl) {
      <i
        [ngClass]="link?.icon"
      class="link-card__icon"></i>
    }
    @if (date) {
      <sb-date
      [date]="date"></sb-date>
    }
    <div>
      <div class="align-center">
        <div class="bold"
        [innerHTML]="link?.isLabelUntranslated ? link?.label : (link?.label | translate)"></div>
        @if (link?.badgeCount) {
          <sb-badge
            [message]="link?.badgeCount.toString()"
            [isMessageTranslated]="false"
            [isRounded]="true"
            badgeClass="danger"
          class="ml-3"></sb-badge>
        }
      </div>
      @if (link?.description) {
        <div
          class="link-card__description"
        [innerHTML]="link?.description | translate:link?.descriptionTranslateParams"></div>
      }
      @if (link?.warning) {
        <div
          class="link-card__description link-card__description--warning"
        [innerHTML]="link?.warning | translate"></div>
      }
    </div>
  </div>
  @if (link?.actions?.length > 0) {
    <div
      class="link-card__actions">
      @if (link?.actions?.length === 1) {
        <sb-button
          buttonClass="link"
          iconClasses="p-15 text-muted"
          [iconName]="link.actionsIcon || 'arrow-right'"
          [iconSize]="link.actionsIconSize"
          [tooltipText]="link?.actions[0].message || 'SB_View'"
          tooltipPlacement="bottom"
        (onClick)="onActionClick(0)"></sb-button>
      }
      @if (link?.actions?.length > 1) {
        <sb-button
          buttonClass="link"
          iconClasses="p-15 text-muted"
          iconName="ellipsis"
          [dropdownItems]="link?.actions"
        (onClick)="onActionClick($event)"></sb-button>
      }
    </div>
  }
  @if (link?.externalUrl) {
    <div class="link-card__external"
      >
      <sb-icon name="followLink"></sb-icon>
    </div>
  }
</div>
